// extracted by mini-css-extract-plugin
export default {"admin-layout":"AdminLayout_admin-layout__LA7A9","content":"AdminLayout_content__KgoDk"};